<template>
  <div>
    <div class="tabla">
      <div class="menu">
        <b-row>
          <b-col>
            <b-button pill class="mb-2 naranja" @click="enrutar('/courier/home')"> <b-icon icon="house" aria-hidden="true" /> </b-button>
          </b-col>
          <b-col>
            <b-button pill class="mb-2 naranja" @click="enrutar('/courier/envios')"><b-icon icon="briefcase" aria-hidden="true" /> </b-button>
          </b-col>
          <b-col>
            <b-button pill class="mb-2 naranja" @click="enrutar('/courier/entrega')"> <b-icon-archive aria-hidden="true" /> </b-button>
          </b-col>
          <b-col>
            <b-button pill class="mb-2 naranja" @click="enrutar('/courier/clientes')"><b-icon icon="person-lines-fill" aria-hidden="true" /> </b-button>
          </b-col>
          <b-col>
            <b-button pill class="mb-2 naranja" @click="enrutar('/courier/productos')"><b-icon icon="shop" aria-hidden="true"/></b-button>
          </b-col>
          <b-col v-if="esAdmin">
            <b-button pill class="mb-2 naranja" @click="enrutar('/courier/reportes')"><b-icon icon="journal" aria-hidden="true"/></b-button>
          </b-col>
          <b-col v-if="esAdmin">
            <b-button pill class="mb-2 naranja" @click="enrutar('/courier/region')">
              <b-icon icon="geo-alt" aria-hidden="true" />
            </b-button>
          </b-col>
          <b-col v-if="esAdmin">
            <b-button pill class="mb-2 naranja" @click="enrutar('/courier/configuracion')"> <b-icon icon="gear" aria-hidden="true"/></b-button>
          </b-col>
        </b-row>
      </div>
      <div class="datos">
        <home v-if="opcion == 'home'" />
        <envios v-if="opcion == 'envios'" :NumeroEnvio="referencia" />
        <clientes v-if="opcion == 'clientes'" />
        <productos v-if="opcion == 'productos'" />
        <reportes v-if="opcion == 'reportes'" />
        <region v-if="opcion == 'region'" />
        <configuracion v-if="opcion == 'configuracion'" />
        <cargar v-if="opcion == 'cargar'" />
        <entrega v-if="opcion == 'entrega'" />
      </div>
    </div>
  </div>
</template>


<script>
import home from "../components/courier/home.vue";
import envios from "../components/courier/envios.vue";
import clientes from "../components/courier/clientes.vue";
import productos from "../components/courier/productos.vue";
import reportes from "../components/courier/reportes.vue";
import region from "../components/courier/region.vue";
import configuracion from "../components/courier/configuracion.vue";
import cargar from "../components/courier/cargar.vue";
import entrega from "../components/courier/entrega.vue";

import firebase from "firebase/app";
import "firebase/firestore";

if (!firebase.apps.length) firebase.initializeApp({ projectId: "diazvelizexpress" });
else firebase.app();

const db = firebase.firestore();

export default {
  firestore:{
    Usuarios:db.collection('Usuario')
  },
  components: { home, envios, clientes, productos, reportes, region, configuracion, cargar, entrega },
  methods: {
    qrViajes() {
      let lastUpdate = localStorage.fechaViajes || null;
      lastUpdate = new Date(lastUpdate);
      let Ahora = new Date();

      if (Ahora > lastUpdate) {
        let fecha = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
        fecha.setDate(fecha.getDate() - 21);

        Ahora.setTime(Ahora.getTime() + 15 * 60 * 1000);

        localStorage.fechaViajes = Ahora;

        db.collection("Viaje")
          .where("fecha", ">", fecha)
          .orderBy("fecha")
          .get()
          .then((rs) => {
            let viajes = rs.docs.map((doc) => {
              let f = doc.data();
              f.fecha = f.fecha.toDate();
              f.id = doc.id;
              return { ...f };
            });

            localStorage.Viajes = JSON.stringify(viajes);
          });
      }
    },

    enrutar(direccion) {
      
      let usr=this.$session.get('userID');

      db.collection('Usuario').doc(usr).update({URL:location.host + direccion});

      event.preventDefault();

      if (window.location.href.indexOf(direccion) == -1) {
        this.qrViajes();
        this.$router.push(direccion);
      }
    },
  },
  data(){
    return {
      esAdmin:false,
      Usuarios:[]
    }
  },
  mounted() {
    this.esAdmin= this.$session.get('EsAdmin');
    this.qrViajes();
  },
  props: ["opcion", "referencia"],
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/ingresar");
    }

    this.$root.$emit("Imprimir", { ok: false });
  },
};
</script>

<style scoped>
.tabla {
  display: table;
  width: 100%;
}
.menu {
  display: table-cell;
  table-layout: fixed;
  width: 60px;
  padding: 15px 1px 0px 1px;
}
.datos {
  display: table-cell;
  border-left: 1px solid #999;
  padding: 3px;
}
.naranja {
  background-color: #e88a3f !important;
  border: 2px solid #555;
  color: #eee;
}
</style>
